module.exports = __webpack_public_path__ + "img/1.f95f79e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.jpg
// module id = 201
// module chunks = 1